import { ELevelResult } from 'Shared/types';
import TabContentGLR from './glr/TabContent';
import TabContentVLR from './vlr/TabContent';
import TabContentPLR from './plr/TabContent';
export default {
    [ELevelResult.Gene]: TabContentGLR,
    [ELevelResult.Variant]: TabContentVLR,
    [ELevelResult.Phenotype]: TabContentPLR,
};
